<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-stat-row">
    <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4]"></div>
  </div>
  <div class="dsk-panel" style="padding:0">
    <div style="display:flex;align-items:center;gap:24px;padding:24px 28px">
      <div style="display:flex;flex-direction:column;gap:10px;flex:1">
        <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
        <div class="dsk-cell dsk-pulse" style="width:180px;height:40px;border-radius:6px"></div>
        <div class="dsk-cell dsk-pulse" style="width:220px;height:13px"></div>
        <div style="display:flex;gap:10px;margin-top:6px">
          <div class="dsk-cell dsk-pulse" style="width:110px;height:38px;border-radius:8px"></div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:8px;min-width:160px">
        <div class="dsk-cell dsk-pulse" style="width:100px;height:11px"></div>
        <div class="dsk-cell dsk-pulse" style="width:130px;height:32px;border-radius:6px"></div>
        <div class="dsk-cell dsk-pulse" style="height:8px;border-radius:4px;margin-top:4px"></div>
        <div class="dsk-cell dsk-pulse" style="width:90px;height:11px"></div>
      </div>
    </div>
  </div>
  <div class="dsk-split dsk-split-3-2" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
        <div class="dsk-cell dsk-pulse" style="width:70px;height:13px"></div>
      </div>
      <div class="dsk-panel-body" style="gap:0;padding:0">
        <div *ngFor="let r of [1,2,3,4,5]" style="display:flex;align-items:center;gap:14px;padding:13px 16px;border-bottom:1px solid #f0eeec">
          <div class="dsk-avatar dsk-pulse" style="border-radius:50%"></div>
          <div style="display:flex;flex-direction:column;gap:5px;flex:1">
            <div class="dsk-cell dsk-pulse" style="width:110px;height:13px"></div>
          </div>
          <div class="dsk-cell dsk-pulse" style="width:60px;height:13px"></div>
          <div class="dsk-cell dsk-pulse" style="width:60px;height:13px"></div>
          <div class="dsk-cell dsk-pulse" style="width:55px;height:13px"></div>
          <div class="dsk-badge dsk-pulse" style="width:66px;border-radius:20px"></div>
        </div>
      </div>
    </div>
    <div style="display:flex;flex-direction:column;gap:14px">
      <div class="dsk-panel">
        <div class="dsk-panel-head"><div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div></div>
        <div class="dsk-panel-body" style="display:flex;align-items:center;gap:16px">
          <div class="dsk-cell dsk-pulse" style="width:88px;height:88px;border-radius:50%;flex-shrink:0"></div>
          <div style="display:flex;flex-direction:column;gap:8px;flex:1">
            <div class="dsk-cell dsk-pulse" style="height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="height:13px"></div>
          </div>
        </div>
      </div>
      <div class="dsk-panel">
        <div class="dsk-panel-head">
          <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
          <div class="dsk-badge dsk-pulse" style="width:24px"></div>
        </div>
        <div class="dsk-panel-body" style="gap:10px">
          <div *ngFor="let p of [1,2,3]" style="display:flex;align-items:center;gap:12px">
            <div class="dsk-cell dsk-pulse" style="width:34px;height:34px;border-radius:9px;flex-shrink:0"></div>
            <div style="display:flex;flex-direction:column;gap:5px;flex:1">
              <div class="dsk-cell dsk-pulse" style="width:110px;height:13px"></div>
              <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
            </div>
            <div class="dsk-btn-sm dsk-pulse" style="width:60px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dsk-split dsk-split-1-1" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-head"><div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div></div>
      <div class="dsk-panel-body" style="gap:12px">
        <div *ngFor="let t of [1,2]" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #f0eeec">
          <div style="display:flex;flex-direction:column;gap:5px;flex:1">
            <div class="dsk-cell dsk-pulse" style="width:120px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
          </div>
          <div class="dsk-badge dsk-pulse" style="width:60px;border-radius:20px"></div>
        </div>
      </div>
    </div>
    <div class="dsk-panel">
      <div class="dsk-panel-head"><div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div></div>
      <div class="dsk-panel-body" style="display:flex;align-items:flex-end;gap:8px;height:120px">
        <div *ngFor="let b of [1,2,3,4,5,6,7]" style="flex:1;display:flex;flex-direction:column;align-items:center;gap:6px">
          <div class="dsk-cell dsk-pulse" [style.height]="(b*14)+'px'" style="width:100%;border-radius:4px 4px 0 0"></div>
          <div class="dsk-cell dsk-pulse" style="width:24px;height:10px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="overview-page" *ngIf="!loading">
  <div class="ov-container">

    <div class="grid-4 mb16">
      <div class="stat-card sc-red">
        <div class="icon"><mat-icon>people_outline</mat-icon></div>
        <div class="label">TOTAL EMPLOYEES</div>
        <div class="value">{{ totalEmployees }}</div>
        <div class="sub">↑ {{ newThisMonth }} new this month</div>
        <div class="bg-blob" style="background:#a52020"></div>
      </div>
      <div class="stat-card sc-green">
        <div class="icon"><mat-icon>check_circle_outline</mat-icon></div>
        <div class="label">PRESENT TODAY</div>
        <div class="value">{{ presentToday }}</div>
        <div class="sub">{{ attendanceRate }}% attendance rate</div>
        <div class="bg-blob" style="background:#166534"></div>
      </div>
      <div class="stat-card sc-amber">
        <div class="icon"><mat-icon>event_note</mat-icon></div>
        <div class="label">ON LEAVE TODAY</div>
        <div class="value">{{ onLeaveToday }}</div>
        <div class="sub">{{ approvedLeaves }} approved · {{ pendingLeavesCount }} pending</div>
        <div class="bg-blob" style="background:#b45309"></div>
      </div>
      <div class="stat-card sc-blue">
        <div class="icon"><mat-icon>schedule</mat-icon></div>
        <div class="label">LATE ARRIVALS</div>
        <div class="value">{{ lateToday }}</div>
        <div class="sub">↑ {{ lateMoreThanYesterday }} more than yesterday</div>
        <div class="bg-blob" style="background:#1d4ed8"></div>
      </div>
    </div>

    <div class="checkin-card mb16">
      <div class="ci-row">
        <div class="ci-left">
          <div class="ci-time-label">LIVE TIME</div>
          <div class="checkin-time" id="dash-clock">{{ timerDisplay }}</div>
          <div class="checkin-date">{{ todayDateStr }}</div>
          <div class="checkin-status" *ngIf="myTodayRecord?.checkIn">
            <div class="status-pill"><div class="pulse-dot"></div> Checked In · {{ checkInTime }}</div>
            <span class="badge badge-green" style="background:rgba(22,101,52,0.2);color:#4ade80" *ngIf="!isLateCheckIn">✓ On Time</span>
            <span class="badge" style="background:rgba(180,83,9,0.15);color:#b45309" *ngIf="isLateCheckIn">⚠ Late</span>
          </div>
          <div class="ci-btns">
            <button class="checkin-btn" (click)="checkIn()" *ngIf="!myTodayRecord?.checkIn" [disabled]="checkingIn">
              {{ checkingIn ? 'Checking in...' : 'Check In' }}
            </button>
            <button class="checkin-btn checkout" (click)="checkOut()" *ngIf="myTodayRecord?.checkIn && !myTodayRecord?.checkOut" [disabled]="checkingOut">
              {{ checkingOut ? 'Checking out...' : 'Check Out' }}
            </button>
            <span class="ci-done" *ngIf="myTodayRecord?.checkOut">
              <mat-icon>check_circle</mat-icon> Day Complete · {{ totalWorked }}
            </span>
          </div>
        </div>
        <div class="ci-right" *ngIf="myTodayRecord?.checkIn && !myTodayRecord?.checkOut">
          <div class="ci-stat-label">WORKING HRS</div>
          <div class="ci-stat-value">{{ timerDisplay }}</div>
          <div class="progress-bar" style="margin-top:6px"><div class="progress-fill" style="background:linear-gradient(90deg,#8b1a1a,#a52020)" [style.width.%]="workPercent"></div></div>
          <div class="ci-stat-sub">{{ workPercent }}% of 8h target</div>
        </div>
      </div>
    </div>

    <div class="grid-3-2 mb16">
      <div class="card">
        <div class="sec-header">
          <span class="sec-title">Today's Attendance Log</span>
          <a class="sec-link" (click)="goToAttendance()">View All →</a>
        </div>
        <table class="att-table">
          <thead>
            <tr>
              <th>EMPLOYEE</th>
              <th>IN</th>
              <th>OUT</th>
              <th>HRS</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rec of todayAttendanceList.slice(0, 5)">
              <td>
                <div class="emp-cell">
                  <div class="emp-avatar-sm" [style.background]="getAvatarColor(rec.employeeName)">{{ getEmpInitials(rec.employeeName) }}</div>
                  <div>
                    <div class="emp-name">{{ rec.employeeName }}</div>
                  </div>
                </div>
              </td>
              <td>{{ rec.checkIn || '—' }}</td>
              <td>{{ rec.checkOut || '—' }}</td>
              <td style="font-weight:700">{{ rec.hours || '—' }}</td>
              <td><span class="badge" [ngClass]="{'badge-green': rec.status==='present', 'badge-yellow': rec.status==='late', 'badge-red': rec.status==='absent'}"><span class="badge-dot"></span>{{ rec.statusLabel }}</span></td>
            </tr>
            <tr *ngIf="todayAttendanceList.length === 0">
              <td colspan="5" class="no-rows">No attendance records today</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="right-col">
        <div class="card">
          <div class="sec-header"><span class="sec-title">Org Overview</span></div>
          <div class="donut-wrap">
            <svg width="88" height="88" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="36" fill="none" stroke="#ede6dc" stroke-width="12"/>
              <circle cx="50" cy="50" r="36" fill="none" stroke="#8b1a1a" stroke-width="12"
                [attr.stroke-dasharray]="presentArc + ' ' + (226 - presentArc)"
                stroke-dashoffset="57" stroke-linecap="round"/>
              <circle cx="50" cy="50" r="36" fill="none" stroke="#c97d10" stroke-width="12"
                [attr.stroke-dasharray]="leaveArc + ' ' + (226 - leaveArc)"
                [attr.stroke-dashoffset]="57 - presentArc" stroke-linecap="round"/>
              <text x="50" y="46" text-anchor="middle" font-size="13" font-weight="800" fill="#1c0e0e" font-family="Bebas Neue,sans-serif" letter-spacing="1">{{ attendanceRate }}%</text>
              <text x="50" y="57" text-anchor="middle" font-size="7.5" fill="#a07055" font-family="Plus Jakarta Sans,sans-serif">Present</text>
            </svg>
            <div class="donut-legend">
              <div class="legend-item"><span class="legend-dot" style="background:#8b1a1a"></span> Present — {{ presentToday }}</div>
              <div class="legend-item"><span class="legend-dot" style="background:#c97d10"></span> On Leave — {{ onLeaveToday }}</div>
              <div class="legend-item"><span class="legend-dot" style="background:#1e40af"></span> Absent — {{ absentToday }}</div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="sec-header">
            <span class="sec-title">Pending Actions</span>
            <span class="badge badge-yellow" *ngIf="pendingLeaveRequests.length > 0">{{ pendingLeaveRequests.length }}</span>
          </div>
          <div class="pending-list">
            <div class="pending-item" *ngFor="let lr of pendingLeaveRequests.slice(0, 3)">
              <div class="pending-icon" style="background:#fef3c7;color:#92400e"><mat-icon>event_note</mat-icon></div>
              <div class="pending-info">
                <div class="pending-title">{{ lr.employeeName }}</div>
                <div class="pending-sub">{{ lr.leaveType | titlecase }} · {{ lr.days }} day{{ lr.days > 1 ? 's' : '' }}</div>
              </div>
              <button class="btn-primary" style="padding:4px 10px;font-size:10px" (click)="approveLeaveReq(lr.id)">Approve</button>
            </div>
            <div *ngIf="pendingLeaveRequests.length === 0" class="no-rows" style="padding:16px;text-align:center;color:#a07055;font-size:12px">
              No pending actions
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-2 mb16">
      <div class="card">
        <div class="sec-header">
          <span class="sec-title">Teams at a Glance</span>
          <a class="sec-link" (click)="navigate('/shifts')">Manage Teams →</a>
        </div>
        <div class="teams-glance">
          <div class="team-row" *ngFor="let lr of pendingLeaveRequests.slice(0, 2)">
            <div><div class="team-name">{{ lr.employeeName }}</div><div class="team-sub">Leave pending</div></div>
            <span class="badge badge-green">Present</span>
          </div>
          <div *ngIf="pendingLeaveRequests.length === 0" style="padding:16px;color:#a07055;font-size:12px;text-align:center">No team data available</div>
        </div>
      </div>
      <div class="card">
        <div class="sec-header">
          <span class="sec-title">Weekly Attendance</span>
          <span class="badge" style="background:rgba(139,26,26,0.1);color:#a52020">This Week</span>
        </div>
        <div class="bar-chart">
          <div class="bar-col" *ngFor="let wd of weekTrend">
            <div class="bar" [style.height.%]="wd.percent" [style.background]="wd.isWeekend ? '#d0bfb0' : 'linear-gradient(180deg,#8b1a1a,#c97d10)'"></div>
            <div class="bar-label">{{ wd.dayName }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
